import { render, staticRenderFns } from "./TableModal.vue?vue&type=template&id=2f1d9a74&scoped=true"
import script from "./TableModal.vue?vue&type=script&lang=js"
export * from "./TableModal.vue?vue&type=script&lang=js"
import style0 from "./TableModal.vue?vue&type=style&index=0&id=2f1d9a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1d9a74",
  null
  
)

export default component.exports